<template>
  <div class="flex flex-col">
    <!-- <input
      id="upload-photo"
      class="mt-6"
      type="file"
      accept="image/*"
      @change="onChange"
    /> -->

    <label
      class="bg-gray-500 hover:bg-gray-700 text-white py-2 px-2 rounded w-full"
    >
      <input
        id="upload-photo"
        class="mt-6 hidden"
        type="file"
        accept="image/*"
        @change="insertImage"
      />
      <span>Upload image</span>
      <FontAwesomeIcon icon="file-upload" class="ml-4" />
    </label>

    <!-- <input
      v-if="$store.state.imageItem.imageUrl"
      type="button"
      value="Upload"
      class="bg-blue-500 hover:bg-blue-700 text-white py-2 px-2 rounded m-4"
      @click="insertImage"
    /> -->
  </div>
</template>
<script>
export default {
  name: 'ImagePicker',
  props: {},
  data() {
    return {}
  },
  methods: {
    onChange(e) {
      const file = e.target.files[0]
      this.$store.commit('changeImage', file)
    },
    insertImage(e) {
      const file = e.target.files[0]
      this.$store.commit('changeImage', file)
      this.$store.commit('insertImage')
    }
  }
}
</script>

<style scoped></style>
